import { z } from 'zod';

import { fieldNameCode, fieldNameIsTrustedDevice } from './EnterCodeForm.constants';
import { messages } from './EnterCodeForm.messages';

export const schema = z.object({
    [fieldNameCode]: z.string().trim().min(1, messages.errorFieldIsRequired),
    [fieldNameIsTrustedDevice]: z.boolean(),
});
